import { copImageNodeFactoryFactory } from "./utils/image/_BaseImage";
import { ImageDefaultTextureLoader } from "../../../core/loader/texture/ImageDefault";
import { ImageExtension } from "../../../core/FileTypeController";
import { CopTypeImage } from "../../poly/registers/nodes/types/Cop";
export class ImageCopNode extends copImageNodeFactoryFactory({
  type: CopTypeImage.IMAGE,
  defaultUrl: ImageDefaultTextureLoader.PARAM_DEFAULT,
  browseExtensions: [ImageExtension.PNG, ImageExtension.JPEG, ImageExtension.JPG],
  getLoader: (url, node) => new ImageDefaultTextureLoader(url, node)
}) {
}
